/** Set REACT_APP_ENABLE_SESSION_PROPOSALS=true to show session publishing, the proposals page and owner/dog invite links. */
export const SESSION_PROPOSALS_ENABLED = process.env.REACT_APP_ENABLE_SESSION_PROPOSALS === "true";
